import { type GraphQLErrorExtensions } from 'graphql'
import { ErrorCode } from 'types/graphql'

const translations: Record<ErrorCode, string> = {
  [ErrorCode.ACCOUNT_WITH_ACTIVE_SUBSCRIPTION]:
    'Vous avez un abonnement en cours. Pour supprimer votre compte, résiliez d\'abord votre abonnement, puis revenez à la fin de celui-ci.',
  [ErrorCode.ACCOUNT_WITH_PAYMENT_IN_RECOVERY]:
    'Un paiement de votre abonnement est en attente ou en échec. Régularisez ou résiliez votre abonnement avant de supprimer votre compte.',
  [ErrorCode.ACCOUNT_WITH_CANCELED_SUBSCRIPTION_AND_FUTURE_END_DATE]:
    'Votre abonnement est résilié et prend fin le {{endDate}}. Vous pourrez supprimer votre compte à partir de cette date.',
}

export default function translate(
  errorKey: ErrorCode,
  params: GraphQLErrorExtensions = {},
) {
  const template = translations[errorKey]

  if (template == null) {
    return null
  }

  if (params.type !== 'date') {
    return template
  }

  return Object.entries(params).reduce((message, [key, value]) => {
    if (key === 'type') {
      return message
    }

    const dateValue = getDateValue(value)
    if (dateValue == null) {
      return message
    }

    return message.replaceAll(
      `{{${key}}}`,
      formatDate(dateValue),
    )
  }, template)
}

const getDateValue = (value: unknown): string | null => {
  if (typeof value === 'string') {
    return value
  }

  if (typeof value !== 'object' || value === null || !('date' in value)) {
    return null
  }

  return typeof value.date === 'string' ? value.date : null
}

const formatDate = (value: string): string => {
  const phpDate = value.match(
    /^(\d{4})-(\d{2})-(\d{2}) \d{2}:\d{2}:\d{2}(?:\.\d+)?$/,
  )

  if (phpDate != null) {
    return `${phpDate[3]}/${phpDate[2]}/${phpDate[1]}`
  }

  return new Intl.DateTimeFormat('fr-FR').format(new Date(value))
}
